import styled from "styled-components";

export const ClientUsersListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const Title = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0 0 30px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;

  div {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 4px;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  min-width: 78px;
  padding: 4px 12px;
  border-radius: 12px;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  text-transform: capitalize;
  background-color: ${(props) => props.color || "#32a728"};
`;
